<template>
  <Modal v-model="open" :title="title">
    <Form
      ref="formItem"
      :model="formItem"
      :label-width="80"
      :rules="ruleValidate"
    >
      <FormItem label="角色名称" prop="role_name">
        <Input
          v-model="formItem.role_name"
          placeholder="请输入角色名称"
          clearable
        />
      </FormItem>
      <FormItem label="角色描述" prop="role_desc">
        <Input
          v-model="formItem.role_desc"
          placeholder="请输入角色描述"
          clearable
        />
      </FormItem>
    </Form>
    <div slot="footer" style="text-align: center">
      <Button @click="cancel('formItem')">关闭</Button>
      <Button type="primary" :loading="loading" @click="ok('formItem')">
        提交
      </Button>
    </div>
  </Modal>
</template>
<script>
import { rolesAdd, rolesUpdate } from '@/api/role'
export default {
  name: 'rolesAddUpdate',
  data() {
    return {
      formItem: {
        role_name: '',
        role_desc: '',
      },
      ruleValidate: {
        role_name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
        ],
        role_desc: [
          { required: true, message: '请输入角色描述', trigger: 'blur' },
        ],
      },
      open: false,
      title: '角色添加',
      loading: false,
    }
  },
  methods: {
    // 初始化表单的函数，用于添加或修改角色
init(params) {
  console.log(params) // 在控制台打印传入的参数，用于调试
  if (params) { // 如果params存在，表示是修改操作
    this.title = '角色修改' // 设置模态框标题为"角色修改"
    this.formItem = JSON.parse(JSON.stringify(params)) // 深拷贝params到formItem，避免直接修改传入的params
    
    // 确保字段名称正确转换
    if (params.roleName !== undefined && !this.formItem.role_name) {
      this.formItem.role_name = params.roleName;
    }
    if (params.roleDesc !== undefined && !this.formItem.role_desc) {
      this.formItem.role_desc = params.roleDesc;
    }
  } else { // 如果params不存在，表示是添加操作
    this.title = '角色添加' // 设置模态框标题为"角色添加"
    this.formItem = {
      role_name: '',
      role_desc: '',
    }
  }
  this.open = true // 打开模态框
},

// 确认提交表单的函数
ok(name) {
  this.$refs[name].validate((valid) => { // 使用表单验证
    if (!valid) return // 如果验证不通过，直接返回
    const postData = JSON.parse(JSON.stringify(this.formItem)) // 深拷贝formItem到postData，准备发送到后端
    if (this.formItem.roleId || this.formItem._id) { // 如果formItem中包含roleId或_id，表示是修改操作
      rolesUpdate(this.formItem) // 调用rolesUpdate API进行角色更新
        .then((res) => { // 处理成功的响应
          if (res.data.code === 200) { // 如果响应码为200，表示成功
            this.$Message.success('角色修改成功') // 显示成功消息
            this.cancel('formItem') // 调用cancel函数重置表单和关闭模态框
            this.$emit('reload') // 触发reload事件，通知父组件重新加载列表
          } else {
            this.$Message.error(res.data.msg) // 如果响应码不是200，显示错误消息
          }
        })
        .catch((err) => { // 处理错误的响应
          this.$Message.error(err) // 显示错误消息
        })
    } else { // 如果formItem中不包含roleId，表示是添加操作
      rolesAdd(postData) // 调用rolesAdd API进行角色添加
        .then((res) => { // 处理成功的响应
          if (res.data.code === 200) { // 如果响应码为200，表示成功
            this.$Message.success('角色添加成功') // 显示成功消息
            this.cancel('formItem') // 调用cancel函数重置表单和关闭模态框
            this.$emit('reload') // 触发reload事件，通知父组件重新加载列表
          } else {
            this.$Message.error(res.data.msg) // 如果响应码不是200，显示错误消息
          }
        })
        .catch((err) => { // 处理错误的响应
          this.$Message.error(err) // 显示错误消息
        })
    }
  })
},

// 取消操作并重置表单的函数
cancel(name) {
  this.formItem = { // 重置formItem对象
    role_name: '', // 清空角色名称
    role_desc: '', // 清空角色描述
  }
  this.$refs[name].resetFields() // 调用表单的resetFields方法重置验证状态
  this.open = false // 关闭模态框
},

  },
  mounted() {},
}
</script>
